import React, { useState } from "react";

const KEY = "redeye_age_ok";

export default function AgeGate({ children }) {
  const [ok, setOk] = useState(() => localStorage.getItem(KEY) === "1");

  if (ok) return children;

  const confirm = () => { localStorage.setItem(KEY, "1"); setOk(true); };

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[100] flex items-center justify-center px-6"
      style={{ background: "#050505 radial-gradient(circle at center, #1A1A1A 0%, #050505 100%)" }}
    >
      <div className="max-w-md w-full text-center fade-up">
        <img src="/logo_wide.webp" alt="RED EYE" className="w-56 mx-auto red-glow mb-8" />
        <h1 className="font-heading font-black text-3xl sm:text-4xl uppercase tracking-wide text-[#F0EDEA]">
          Are you <span className="text-[#E60000]">21+</span>?
        </h1>
        <p className="text-[#A8A2A0] mt-4 mb-8 text-sm">
          You must be 21 years of age or older to enter this site.
        </p>
        <div className="flex flex-col gap-3">
          <button data-testid="age-confirm-btn" onClick={confirm} className="btn-skew btn-primary w-full">
            <span>Yes, I am 21+</span>
          </button>
          <a href="https://www.google.com" className="btn-skew btn-secondary w-full" data-testid="age-deny-btn">
            <span>No, exit</span>
          </a>
        </div>
      </div>
    </div>
  );
}
